<template>
    <div class="px-5">
        <div class="px-4 pb-5 pt-2">
            <div class="row">
                <div class=" btn-home  col-md-12 mt-3 mb-4 d-flex justify-content-end">
                    <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            <ul class="nav" id="myTab" role="tablist">
                <li class="nav-item  " role="presentation">
                    <button @click="changePage('cargo')" :class="{'item-button':true, 'nav-link': true, 'active': page === 'cargo' }" id="home-tab" type="button">
                        Cargo
                    </button>
                </li>
                <li class="nav-item  " role="presentation">
                    <button @click="changePage('banco')" :class="{ 'item-button':true,'nav-link': true, 'active': page === 'banco' }" id="profile-tab" type="button">
                        Bancos
                    </button>
                </li>
                <li class="nav-item " role="presentation">
                    <button @click="changePage('tipo_contrato')" :class="{ 'item-button':true,'nav-link': true, 'active': page === 'tipo_contrato' }" id="home-tab" type="button">
                        Tipo de Contrato
                    </button>
                </li>
                <li class="nav-item " role="presentation">
                    <button @click="changePage('turno')" :class="{ 'item-button':true,'nav-link': true, 'active': page === 'turno' }" id="profile-tab" type="button">
                        Turno
                    </button>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <Cargo v-if="page=='cargo'" />
                <Banco v-if="page=='banco'" />
                <TipoContrato v-if="page=='tipo_contrato'" />
                <Turno v-if="page=='turno'" />
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import {
        mapActions
    } from "vuex";
    import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
    import Cargo from '@/components/Personal/Pages/Maintenance/Position.vue';
    import Banco from '@/components/Personal/Pages/Maintenance/Bank.vue';
    import TipoContrato from '@/components/Personal/Pages/Maintenance/TypeContract.vue';
    import Turno from '@/components/Personal/Pages/Maintenance/Turn.vue';

    export default {
        name: "c-mantenedores-pages-personal",
        components: {
            SweetAlert,
            Cargo,
            Banco,
            TipoContrato,
            Turno,
        },
        data() {
            return {
                swal: null,
                page: 'cargo',
            };
        },
        computed: {
    
        },
        created() {
            //this.mtdGetCampus();
        },
        methods: {
            ...mapActions(["get", "post"]),
    
            changePage: function (page) {
                this.page = page;
    
            },
            returnHome: function () {
            this.$emit("mtdChangePage", 'home');
        },
        }
    }
    </script>
    